import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("h1", null, [
      _createTextVNode(_toDisplayString(_ctx.plural ? _ctx.$tc(_ctx.title, 2) : _ctx.$t(_ctx.title)) + " ", 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.subtitle)), 1)
    ])
  ]))
}